import React, { useCallback, useEffect } from 'react';
import { useSecureFormPopupStore } from '../stores/secureFormPopupStore';
import { useSendSecureFormToken } from '../hooks/useSendSecureFormToken';
import { v4 as uuidV4 } from 'uuid';
import { pubsub } from './pubsub';
import { EventSource, EventType, MessageType } from '../graphql/graphql';
import { useTranslation } from 'react-i18next';
import { Option } from 'effect';
export const SecureFormPopupController = () => {
    const { url, invitationId, clearSecureFormPopupInfo, from, title, closePopupInfo, } = useSecureFormPopupStore();
    const sendSecureFormToken = useSendSecureFormToken();
    const { t } = useTranslation();
    const messageReceiver = useCallback((event) => {
        if (Option.isNone(url)) {
            return;
        }
        const tokenizerDomain = new URL(url.value).origin;
        if (event.origin.includes(tokenizerDomain)) {
            const data = JSON.parse(event.data);
            const { state, token } = data;
            if (state === 'submit') {
                const id = uuidV4();
                const timestamp = Date.now().toString();
                sendSecureFormToken({ token, invitationId, timestamp, id })
                    .then(() => {
                    pubsub.publish({
                        id: uuidV4().toString(),
                        persistedTimestamp: Date.now().toString(),
                        type: EventType.Message,
                        messageEvent: {
                            messageType: MessageType.Text,
                            from,
                            text: {
                                message: t('SECURE_FORM_SENT_MESSAGE', { title, from }),
                            },
                        },
                        source: EventSource.Advisor,
                        loading: false,
                        failed: false,
                        local: true,
                        historic: false,
                        readByCustomer: true,
                    });
                    closePopupInfo();
                })
                    .catch(() => { });
            }
            else if (state === 'error') {
                clearSecureFormPopupInfo();
            }
        }
    }, [
        url,
        invitationId,
        sendSecureFormToken,
        clearSecureFormPopupInfo,
        closePopupInfo,
        from,
        title,
        t,
    ]);
    useEffect(() => {
        window.addEventListener('message', messageReceiver);
        return () => window.removeEventListener('message', messageReceiver);
    }, [messageReceiver]);
    return Option.match(url, {
        onNone: () => null,
        onSome: () => {
            return React.createElement(React.Fragment, null);
        },
    });
};
